import { IS_BILLING_ENABLED } from '@/shared/config';

import type { Profile } from '../types';

export function isUserOnboarded(profile?: Profile): boolean {
  if (!profile) return false;

  const isUserVerified = IS_BILLING_ENABLED ? profile.is_verified : true;
  const isUserSettled = profile.is_email_confirmed && isUserVerified;
  const isUserMember = profile.is_member && profile.is_email_confirmed;

  return Boolean(isUserSettled || isUserMember);
}
